import type { ConfirmPopupDetails } from "./types";
import "./styles.css";

type Props = {
    onClose: () => void;
    details?: ConfirmPopupDetails;
};

export default function ConfirmPopup({ onClose, details }: Props) {
    if (!details) return null;

    const variant = details.variant ?? "danger";

    const handleConfirm = () => {
        details.onConfirm();
        onClose();
    };

    const handleDecline = () => {
        details.onDecline?.();
        onClose();
    };

    return (
        <div className="confirm-popup">
            {details.icon && (
                <div className={`confirm-popup-icon-wrap confirm-popup-icon-wrap--${variant}`}>
                    <img src={details.icon} className="confirm-popup-icon" alt="" />
                </div>
            )}
            <p className="confirm-popup-message">{details.message}</p>
            <div className="confirm-popup-actions">
                <button type="button" className="confirm-popup-cancel" onClick={handleDecline}>
                    {details.cancelLabel ?? "إلغاء"}
                </button>
                <button type="button" className={`confirm-popup-confirm confirm-popup-confirm--${variant}`} onClick={handleConfirm}>
                    {details.confirmLabel ?? "تأكيد"}
                </button>
            </div>
        </div>
    );
}
